import React, { useEffect, useState } from "react";
import { Button, Flex, Modal, Space } from "antd";
import { toast } from "react-toastify";
import { LeftOutlined } from "@ant-design/icons";
import CustomLoader from "../../../components/common/UI/Loader";
import ENDPOINTS from "../../../services/endpoint";
import apiInstance from "../../../services/apiService";
import SettingsSidebarHeader from "../../../components/common/SettingsSidebarHeader";
import "./index.scss";

interface TopUpScreenProps {
  handleBackToPrevious?: () => void;
  showHeader?: boolean;
}

const TopUpScreen: React.FC<TopUpScreenProps> = ({
  handleBackToPrevious,
  showHeader = true,
}) => {
  const [selectedAmount, setSelectedAmount] = useState<number | null>(null);
  const [credits, setCredits] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [updating, setUpdating] = useState<boolean>(false);
  const [paymentGatewayModalOpen, setPaymentGatewayModalOpen] =
    useState<boolean>(false);
  const [paymentGatewayDetails, setPaymentGatewayDetails] = useState<any>(null);

  const getCredits = async () => {
    const url = ENDPOINTS.ADD_CREDITS;

    setLoading(true);
    try {
      const response = await apiInstance.get(url);
      const data = response.data.data;
      setCredits(data);
    } catch (error: any) {
      console.error(error);
      toast.error(error.msg || "There was an error fetching credits");
    } finally {
      setLoading(false);
    }
  };

  const updateCredit = async () => {
    const url = ENDPOINTS.ADD_CREDITS;

    setUpdating(true);
    try {
      const response = await apiInstance.post(url, {
        credit: selectedAmount,
      });
      const message = response.data.message;
      toast.success(message || "Updated credit successfully");
    } catch (error: any) {
      console.error(error);
      if (error?.response.data.hostedpageDetails) {
        toast.info("Add payment card to proceed with purchasing.");
        setPaymentGatewayDetails(error?.response.data.hostedpageDetails);
        setPaymentGatewayModalOpen(true);
      } else {
        toast.error(error?.response.data.message || error?.message);
      }
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    getCredits();
  }, []);

  return (
    <>
      <div className="topup-container">
        {showHeader && (
          <SettingsSidebarHeader
            title=""
            handleBackClick={handleBackToPrevious}
          />
        )}

        {loading ? (
          <Flex className="h-full w-full" justify="center" align="center">
            <CustomLoader />
          </Flex>
        ) : credits ? (
          <div className="topup-card">
            <h2 className="topup-title">
              {!showHeader && (
                <LeftOutlined
                  className="arrow-btn"
                  onClick={handleBackToPrevious}
                />
              )}
              Top up your number
            </h2>
            {/* <div className="topup-field">
                  <label className="topup-label">Number</label>
                  <label className="topup-labels">+9712345566</label>
                </div> */}
            <Space direction="vertical" align="start" size="small">
              <h3 className="topup-label">Amount</h3>
              <p className="topup-sub-label">Enter Amount</p>
            </Space>
            <div className="topup-buttons">
              {credits.map((amount) => (
                <Button
                  disabled={updating}
                  key={amount}
                  className={`topup-button ${
                    selectedAmount === amount ? "topup-button-selected" : ""
                  }`}
                  onClick={() => setSelectedAmount(amount)}
                >
                  ${amount}
                </Button>
              ))}
            </div>
            <Button
              loading={updating}
              onClick={updateCredit}
              className="top-up-next-btn modal-ok-btn"
            >
              Next
            </Button>
          </div>
        ) : (
          <p>No credits</p>
        )}
      </div>

      <Modal
        open={paymentGatewayModalOpen}
        onCancel={() => setPaymentGatewayModalOpen(false)}
        footer={null}
      >
        <iframe
          title="payment gateway"
          src={paymentGatewayDetails?.url}
          width="100%"
          height="660px"
          style={{ border: "none" }}
          allowFullScreen
        />
      </Modal>
    </>
  );
};

export default TopUpScreen;
